// Shared form helpers: phone formatter, US states, plan/status labels.
// Kept intentionally small — reused by client/lead/onboarding forms.

// Top California cities for the Discover autocomplete list (datalist).
export const CA_CITIES = [
  "Los Angeles", "San Diego", "San Jose", "San Francisco", "Fresno",
  "Sacramento", "Long Beach", "Oakland", "Bakersfield", "Anaheim",
  "Santa Ana", "Riverside", "Stockton", "Irvine", "Chula Vista",
  "Fremont", "San Bernardino", "Modesto", "Fontana", "Oxnard",
  "Moreno Valley", "Huntington Beach", "Glendale", "Santa Clarita",
  "Garden Grove", "Oceanside", "Rancho Cucamonga", "Santa Rosa",
  "Ontario", "Elk Grove", "Corona", "Lancaster", "Palmdale",
  "Salinas", "Hayward", "Pomona", "Escondido", "Sunnyvale",
  "Torrance", "Orange", "Fullerton", "Pasadena", "Thousand Oaks",
  "Visalia", "Simi Valley", "Roseville", "Concord", "Vallejo",
  "Berkeley", "Fairfield", "Richmond", "Murrieta", "Burbank",
  "Antioch", "Temecula", "Norwalk", "Daly City", "El Monte",
  "Ventura", "West Covina", "Costa Mesa", "Downey", "Inglewood",
  "Carlsbad", "San Mateo", "Compton", "Vista", "Mission Viejo",
  "South Gate", "Vacaville", "Carson", "Hesperia", "Redding",
  "Santa Monica", "Westminster", "Santa Barbara", "Chico",
  "Newport Beach", "San Marcos", "Whittier", "Hawthorne",
  "Citrus Heights", "Tracy", "Alhambra", "Livermore", "Buena Park",
  "Menifee", "Lakewood", "Merced", "Napa", "Redwood City",
  "Bellflower", "Indio", "Chino", "Baldwin Park", "Chino Hills",
];


export const US_STATES = [
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"],
  ["CA", "California"], ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"],
  ["FL", "Florida"], ["GA", "Georgia"], ["HI", "Hawaii"], ["ID", "Idaho"],
  ["IL", "Illinois"], ["IN", "Indiana"], ["IA", "Iowa"], ["KS", "Kansas"],
  ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"], ["MD", "Maryland"],
  ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"], ["MS", "Mississippi"],
  ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"],
  ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"], ["NY", "New York"],
  ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"], ["OK", "Oklahoma"],
  ["OR", "Oregon"], ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"],
  ["SD", "South Dakota"], ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"],
  ["VT", "Vermont"], ["VA", "Virginia"], ["WA", "Washington"], ["WV", "West Virginia"],
  ["WI", "Wisconsin"], ["WY", "Wyoming"], ["DC", "District of Columbia"],
];

// Format a raw string of digits into US phone: "(555) 123-4567"
// Accepts partial input and formats progressively as user types.
export function formatPhone(value) {
  const digits = (value || "").replace(/\D/g, "").slice(0, 10);
  if (digits.length === 0) return "";
  if (digits.length < 4) return `(${digits}`;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

// Return the raw 10-digit form (for validation / storage)
export function phoneDigits(value) {
  return (value || "").replace(/\D/g, "");
}

export function isValidEmail(v) {
  if (!v) return true; // empty allowed (optional field)
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}

// Format a ZIP: 5 digits or 5+4
export function formatZip(value) {
  const digits = (value || "").replace(/\D/g, "").slice(0, 9);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

// Ensure URL has protocol (http/https)
export function normalizeUrl(v) {
  const t = (v || "").trim();
  if (!t) return "";
  if (/^https?:\/\//i.test(t)) return t;
  return `https://${t}`;
}
